export default __webpack_public_path__ + "static/media/greenicon.8fa34d3a.svg";